import React, { ChangeEvent, useEffect, useState } from "react";
import api from "../../../utils/api";
import dots from "../../../img/dots.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  errorCancelTrigger,
  errorMessageDefault,
  successCancelTrigger,
  waitingMessage,
} from "../../../Components/Toastify";
import { adjustTime, adjustTimeWithout3Hour } from "../../../utils/utils";
import { Filters, ITriggerList, ITriggerListFilter } from "../../types";
import loupe from "../../../img/loupe.png";
import { months, years } from "../../../utils/textAux";
import { validatedUser } from "../../../utils/validateUser";
import whatsappIcon from "../../../img/whatsapp.png";
import teamsIcon from "../../../img/teams.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DraggableComponent } from "../../../Components/Draggable";
import { DevAuthModal } from "../../../Components/DevAuthModal";
import { useDevAuth } from "../../../hooks/useDevAuth";

export function TriggerList() {
  const [searchParams, setSearchParams] = useSearchParams();
  var botId = searchParams.get("bot_id") ?? "0";
  const history = useNavigate();

  const {
    isDevMode,
    showDevModal,
    isLoading,
    botIdValue,
    handleBotIdChange,
    handleBotIdSubmit,
    handleCloseModal,
  } = useDevAuth();

  useEffect(() => {
    const fetchData = async () => {
      // Em DEV mode com modal aberto, não faz nada
      if (isDevMode && showDevModal) {
        return;
      }

      // Se não tem bot_id válido, não faz nada
      if (!botId || botId === "0") {
        return;
      }

      if (isDevMode) {
        return;
      }

      const logged: any =
        (await validatedUser(
          searchParams.get("bot_id"),
          searchParams.get("token"),
          searchParams.get("url_base_api"),
        )) ?? false;
      if (!logged.logged) {
        history(`/template-warning-no-whats?bot_id=${botId}`);
      }
    };
    fetchData();
  }, [isDevMode, showDevModal, botId]);
  const now = new Date();
  const [triggerList, setTriggerList] = useState<ITriggerList[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [hiddenVideo, setHiddenVideo] = useState<boolean>(false);
  const [downloadStatus, setDownloadStatus] = useState<
    "idle" | "loading" | "done"
  >("idle");
  const [downloadingName, setDownloadingName] = useState<string>("");
  const [filtro, setFiltro] = useState<string>("");
  const [dataTreat, setDataTreat] = useState<any>([]);
  const [sortType, setSortType] = useState<string>("data_criacao");
  const [sortOrder, setOrderSort] = useState<string>("desc");
  const [changeDateFilter, setChangeDateFilter] = useState<boolean>(false);
  const [initDate, setInitDate] = useState({
    day: 1,
    month: now.getMonth() + 1,
    year: 2025,
  });
  const [finalDate, setFinalDate] = useState({
    day: now.getDate(),
    month: now.getMonth() + 1,
    year: now.getFullYear(),
  });
  const [filters, setFilters] = useState<ITriggerListFilter>({
    campaign_name: "",
    template_name: "",
    category: "",
    type_trigger: "",
    time_trigger: "",
    data_criacao: "",
    status: {
      executado: true,
      entregue: true,
      aguardando: true,
      enviado: true,
      erro: true,
      cancelado: true,
      criando: true,
    },
  });

  const [selectedChannel, setSelectedChannel] = useState<string>("todos");

  useEffect(() => {
    if (!isDevMode && searchParams.get("bot_id") === null) {
      window.location.href = "https://in.bot/inbot-admin";
    }
  }, [isDevMode]);
  const showVideo = () => {
    setHiddenVideo(!hiddenVideo);
  };

  const filtersByStatus = (triggersList: any) => {
    const dadosFiltrados = triggersList.filter((trigger: any) => {
      if (
        trigger.template_name !== null &&
        filtro !== "" &&
        !trigger.template_name.toLowerCase().includes(filtro.toLowerCase()) &&
        trigger.campaign_name !== null &&
        filtro !== "" &&
        !trigger.campaign_name.toLowerCase().includes(filtro.toLowerCase())
      ) {
        return false;
      }

      if (selectedChannel !== "todos" && trigger.channel !== selectedChannel) {
        return false;
      }

      if (
        (filters.status.aguardando && trigger.status === "aguardando") ||
        (filters.status.enviado && trigger.status === "enviado") ||
        (filters.status.executado && trigger.status === "executado") ||
        (filters.status.entregue && trigger.status === "entregue") ||
        (filters.status.erro && trigger.status === "erro") ||
        (filters.status.cancelado && trigger.status === "cancelado") ||
        (filters.status.criando && trigger.status === "criando")
      ) {
        return true;
      }

      return false;
    });

    setDataTreat(filterByDate(dadosFiltrados));
  };

  const handleInitSort = (value: string, orderBy: string) => {
    setSortType(value);
    setOrderSort(orderBy);
  };
  const handleSort = (outrosDadosFiltrados: any) => {
    const sortedItems = [...outrosDadosFiltrados];
    if (sortType === "") {
      return sortedItems;
    }

    // Campos numéricos que precisam ser convertidos para número
    const numericalFields = ["total", "erro", "enviado", "engajado"];

    // Campos de data que precisam ser convertidos para Date
    const dateFields = ["data_criacao", "time_trigger"];

    if (numericalFields.includes(sortType)) {
      if (sortOrder === "asc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a[sortType] !== undefined && a[sortType] !== null
              ? Number(a[sortType])
              : 0;
          const valorB =
            b[sortType] !== undefined && b[sortType] !== null
              ? Number(b[sortType])
              : 0;
          return valorA - valorB;
        });
      } else if (sortOrder === "desc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a[sortType] !== undefined && a[sortType] !== null
              ? Number(a[sortType])
              : 0;
          const valorB =
            b[sortType] !== undefined && b[sortType] !== null
              ? Number(b[sortType])
              : 0;
          return valorB - valorA;
        });
      }
    } else if (sortType === "entregue") {
      if (sortOrder === "asc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a.channel === "whatsapp"
              ? a.entregue !== undefined && a.entregue !== null
                ? Number(a.entregue)
                : 0
              : Number(a.enviado || 0) + Number(a.entregue || 0);
          const valorB =
            b.channel === "whatsapp"
              ? b.entregue !== undefined && b.entregue !== null
                ? Number(b.entregue)
                : 0
              : Number(b.enviado || 0) + Number(b.entregue || 0);
          return valorA - valorB;
        });
      } else if (sortOrder === "desc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a.channel === "whatsapp"
              ? a.entregue !== undefined && a.entregue !== null
                ? Number(a.entregue)
                : 0
              : Number(a.enviado || 0) + Number(a.entregue || 0);
          const valorB =
            b.channel === "whatsapp"
              ? b.entregue !== undefined && b.entregue !== null
                ? Number(b.entregue)
                : 0
              : Number(b.enviado || 0) + Number(b.entregue || 0);
          return valorB - valorA;
        });
      }
    } else if (dateFields.includes(sortType)) {
      if (sortOrder === "asc") {
        sortedItems.sort((a, b) => {
          const dateA =
            a[sortType] !== undefined && a[sortType] !== null
              ? new Date(a[sortType]).getTime()
              : 0;
          const dateB =
            b[sortType] !== undefined && b[sortType] !== null
              ? new Date(b[sortType]).getTime()
              : 0;
          return dateA - dateB;
        });
      } else if (sortOrder === "desc") {
        sortedItems.sort((a, b) => {
          const dateA =
            a[sortType] !== undefined && a[sortType] !== null
              ? new Date(a[sortType]).getTime()
              : 0;
          const dateB =
            b[sortType] !== undefined && b[sortType] !== null
              ? new Date(b[sortType]).getTime()
              : 0;
          return dateB - dateA;
        });
      }
    } else {
      if (sortOrder === "asc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a[sortType] !== undefined && a[sortType] !== null
              ? a[sortType]
              : "Z";
          const valorB =
            b[sortType] !== undefined && b[sortType] !== null
              ? b[sortType]
              : "Z";
          return valorA.localeCompare(valorB);
        });
      } else if (sortOrder === "desc") {
        sortedItems.sort((a, b) => {
          const valorA =
            a[sortType] !== undefined && a[sortType] !== null
              ? a[sortType]
              : "Z";
          const valorB =
            b[sortType] !== undefined && b[sortType] !== null
              ? b[sortType]
              : "Z";
          return valorB.localeCompare(valorA);
        });
      }
    }
    return sortedItems;
  };

  const filterByDate = (values: any) => {
    const dadosFiltrados = values.filter((trigger: any) => {
      const triggerDate = new Date(trigger.data_criacao);

      const dataInicial = new Date(
        initDate.year,
        initDate.month - 1,
        initDate.day,
        0,
        0,
        0,
      );
      const dataFinal = new Date(
        finalDate.year,
        finalDate.month - 1,
        finalDate.day,
        23,
        59,
        59,
      );

      return triggerDate >= dataInicial && triggerDate <= dataFinal;
    });
    return dadosFiltrados;
  };

  const handleFiltroChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFiltro(e.target.value);
    setChangeDateFilter((previous) => !previous);
  };

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const loadTriggers = () => {
    return api
      .get(`/whatsapp/trigger-bot/${botId}`)
      .then((resp) => {
        setTriggerList(resp.data.data);
        filtersByStatus(resp.data.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados:", error);
      });
  };

  useEffect(() => {
    setLoading(true);
    api.get(`/whatsapp/trigger-bot/${botId}`).then((resp) => {
      setTriggerList(resp.data.data);
      filtersByStatus(resp.data.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      api
        .get(`/whatsapp/trigger-bot/${botId}`)
        .then((resp) => {
          setTriggerList(resp.data.data);
          filtersByStatus(resp.data.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        });
    }, 15000);
    return () => clearInterval(intervalId);
  }, [botId, initDate, finalDate, filtro, filters, selectedChannel]);

  function detailedTrigger(id: number) {
    const sortTrigger = handleSort(dataTreat);
    const triggerId = sortTrigger[id].id;
    const triggerStatus = sortTrigger[id].status;
    history(
      `/trigger-details?bot_id=${botId}&token=${searchParams.get("token")}&url_base_api=${searchParams.get("url_base_api")}`,
      {
        state: {
          triggerId: triggerId,
          urlLogo: "",
          triggerStatus: triggerStatus,
        },
      },
    );
  }
  const changeStatus = (id: number) => {
    const sortTrigger = handleSort(dataTreat);
    waitingMessage();
    const triggerId = sortTrigger[id].id;

    api
      .put(`/whatsapp/trigger/${triggerId}`)
      .then((resp) => {
        successCancelTrigger();
        loadTriggers();
      })
      .catch((error) => {
        errorCancelTrigger();
        console.log(error);
      });
  };
  function statusName(status: string) {
    switch (status) {
      case "enviado":
        return "Enviado";
      case "executado":
        return "Executado";
      case "aguardando":
        return "Aguardando";
      case "erro":
        return "Erro";
      case "criando":
        return "Criando";
      default:
        return "Cancelado";
    }
  }
  function statusColor(status: string) {
    switch (status) {
      case "enviado":
        return "blue";
      case "executado":
        return "green";
      case "aguardando":
        return "orange";
      case "cancelado":
        return "gray";
      case "criando":
        return "purple";
      default:
        return "red";
    }
  }

  const handleStatusChange = (statusKey: keyof Filters["status"]) => {
    setFilters({
      ...filters,
      status: {
        ...filters.status,
        [statusKey]: !filters.status[statusKey],
      },
    });
    setChangeDateFilter((previous) => !previous);
  };

  useEffect(() => {
    filtersByStatus(triggerList);
  }, [changeDateFilter]);

  const exportListCsv = () => {
    setDownloadingName("");
    setDownloadStatus("loading");
    try {
      const processedData = handleSort(dataTreat).map((trigger: any) => ({
      "Nome da campanha": trigger.campaign_name,
      Template: trigger.template_name,
      "Número de Origem": trigger.phone_trigger ?? "--",
      Categoria: capitalizeFirstLetter(trigger.category ?? "--"),
      "Data criação": trigger.data_criacao
        ? adjustTimeWithout3Hour(trigger.data_criacao)
        : "--",
      "Data envio": trigger.time_trigger
        ? adjustTimeWithout3Hour(trigger.time_trigger)
        : "--",
      Status: trigger.status,
      Canal:
        trigger.channel === "whatsapp"
          ? "Whatsapp"
          : trigger.channel === "teams"
            ? "Teams"
            : "Outro",
      "Total de disparos": trigger.total,
      Erro: trigger.erro,
      "Enviado não entregue":
        statusName(trigger.status) == "Executado" &&
        trigger.channel === "whatsapp"
          ? trigger.enviado
          : "0",
      Entregue: trigger.entregue,
      Engajamento: trigger.status === "aguardando" ? 0 : trigger.engajado,
      "Usuário/Origem da Criação":
        trigger.triggerOrigin === "MANUAL"
          ? trigger.created_by || "Manual"
          : capitalizeFirstLetter(trigger.triggerOrigin),
    }));

      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ";" });
      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      saveAs(blob, "campanhas.csv");
      setDownloadStatus("done");
    } catch (error) {
      console.error("Erro ao exportar CSV:", error);
      errorMessageDefault("Erro ao exportar a lista de campanhas");
      setDownloadStatus("idle");
    }
  };

  const sanitizeFileName = (name: string) => {
    return (name ?? "")
      .replace(/[\/\\:*?"<>|]/g, "-")
      .replace(/\s+/g, " ")
      .trim();
  };

  const downloadCustomersCsv = async (index: number) => {
    const sortTrigger = handleSort(dataTreat);
    const trigger = sortTrigger[index];
    const triggerId = trigger?.id;
    if (!triggerId) {
      errorMessageDefault("Campanha inválida para download");
      return;
    }
    const safeName = sanitizeFileName(trigger?.campaign_name);
    const fileName = `${safeName || `disparo-${triggerId}`}.csv`;

    setDownloadingName(trigger?.campaign_name ?? "");
    setDownloadStatus("loading");
    try {
      const resp = await api.get(`/whats-customer/${triggerId}`);
      const customers: any[] = resp.data?.data ?? [];

      const isPhone = customers.some(
        (c) => c.phone !== null && c.phone !== undefined && c.phone !== "",
      );
      const contactHeader = isPhone ? "Telefone" : "E-mail";

      const variableKeys = Array.from(
        { length: 9 },
        (_, i) => `variable_${i + 1}`,
      ).filter((key) =>
        customers.some(
          (c) => c[key] !== null && c[key] !== undefined && c[key] !== "",
        ),
      );

      const rows = customers.map((c) => {
        const row: Record<string, any> = {};
        row[contactHeader] = isPhone ? (c.phone ?? "") : (c.email ?? "");
        variableKeys.forEach((key, i) => {
          row[`Var. ${i + 1}`] = c[key] ?? "";
        });
        row["Status"] = c.status ?? "";
        row["Horário de criação"] = c.data_criacao
          ? adjustTime(c.data_criacao)
          : "";
        row["Horário de envio"] = c.data_disparo
          ? adjustTime(c.data_disparo)
          : "";
        row["Engajamento"] =
          trigger.status?.toLowerCase() !== "aguardando" && c.engagement
            ? adjustTimeWithout3Hour(c.engagement)
            : "";
        row["ID de usuário"] = c.phone ?? "";
        row["Log"] = c.log ?? "";
        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ";" });
      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      saveAs(blob, fileName);
      setDownloadStatus("done");
    } catch (error) {
      console.error("Erro ao baixar CSV:", error);
      errorMessageDefault("Erro ao baixar os dados da campanha");
      setDownloadStatus("idle");
      setDownloadingName("");
    }
  };

  const closeDownloadModal = () => {
    setDownloadStatus("idle");
    setDownloadingName("");
  };

  return (
    <div style={{ width: "95%", padding: "10px 0px" }}>
      <ToastContainer />
      <DevAuthModal
        isOpen={showDevModal}
        botIdValue={botIdValue}
        onBotIdChange={handleBotIdChange}
        onSubmit={handleBotIdSubmit}
        onClose={handleCloseModal}
        isLoading={isLoading}
      />
      <div>
        <div>
          <h1
            style={{
              fontSize: "23px",
              fontWeight: "bolder",
              color: "#004488",
              width: "100%",
            }}
            className="title_2024"
          >
            Gerenciar Campanhas
          </h1>
        </div>
        <div className="column-align" style={{ alignItems: "center" }}>
          <div
            className="hr_color"
            style={{ width: "97%", marginTop: "15px" }}
          ></div>
          <div style={{ textAlign: "end", width: "94%" }}>
            <span style={{ cursor: "pointer" }} onClick={() => showVideo()}>
              Não sabe como criar template?{" "}
              <strong style={{ color: "blue" }}>Assista nosso vídeo</strong>
            </span>
          </div>
        </div>
        {hiddenVideo && (
          <DraggableComponent
            urlVideo={
              "https://www.loom.com/embed/e5216eb8145c4eaaae86b3e76b5f6dd0?sid=b6e75c08-5db3-41b4-bb0a-c029504dd33a"
            }
            showVideo={showVideo}
          />
        )}
        <div
          className="row"
          style={{ margin: "20px", display: "flex", alignItems: "end" }}
        >
          <input
            onChange={handleFiltroChange}
            value={filtro}
            type="text"
            style={{
              borderRight: "none",
              width: "300px",
              borderRadius: "20px 0px 0px 20px",
              paddingLeft: "20px",
            }}
            placeholder="Buscar por nome ou template"
          />
          <button
            style={{
              borderLeft: "none",
              borderRadius: "0px 20px 20px 0px",
              width: "50px",
            }}
          >
            <img src={loupe} alt="" width={20} height={20} />
          </button>
        </div>
        <div
          className="column"
          style={{ margin: "20px", borderRadius: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontWeight: "bolder",
              borderRadius: "20px",
            }}
          >
            <div style={{ margin: "10px 0px", textAlign: "left" }}>
              <span style={{ color: "#002080", fontWeight: "bolder" }}>
                Data de criação:{" "}
              </span>
              <select
                value={initDate.day}
                onChange={(e) =>
                  setInitDate((prevState) => ({
                    ...prevState,
                    day: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {[...Array(31).keys()].map((i) => (
                  <option key={i + 1} value={(i + 1).toString()}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <select
                value={initDate.month}
                onChange={(e) =>
                  setInitDate((prevState) => ({
                    ...prevState,
                    month: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {months.map((month, key) => (
                  <option value={key + 1}>{month}</option>
                ))}
              </select>
              <select
                value={initDate.year}
                onChange={(e) =>
                  setInitDate((prevState) => ({
                    ...prevState,
                    year: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {years.map((year) => (
                  <option value={year}>{year}</option>
                ))}
              </select>
              <span
                style={{
                  color: "#002080",
                  fontWeight: "bolder",
                  margin: "0px 10px 0px 10px",
                }}
              >
                até
              </span>
              <select
                value={finalDate.day}
                onChange={(e) =>
                  setFinalDate((prevState) => ({
                    ...prevState,
                    day: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {[...Array(31).keys()].map((i) => (
                  <option key={i + 1} value={(i + 1).toString()}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <select
                value={finalDate.month}
                onChange={(e) =>
                  setFinalDate((prevState) => ({
                    ...prevState,
                    month: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {months.map((month, key) => (
                  <option value={key + 1}>{month}</option>
                ))}
              </select>
              <select
                value={finalDate.year}
                onChange={(e) =>
                  setFinalDate((prevState) => ({
                    ...prevState,
                    year: Number(e.target.value),
                  }))
                }
                className="input-values litle-input"
              >
                {years.map((year) => (
                  <option value={year}>{year}</option>
                ))}
              </select>
              <button
                onClick={() => setChangeDateFilter((previous) => !previous)}
                className="button-blue"
              >
                Buscar
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                margin: "10px 0px",
              }}
            >
              <div
                className="row-align"
                style={{ marginBottom: "30px", alignItems: "center" }}
              >
                <span style={{ color: "#002080", fontWeight: "bolder" }}>
                  Status:{" "}
                </span>
                <div
                  className={
                    filters.status.aguardando
                      ? "border_gradient"
                      : "border_gradient-gray"
                  }
                  style={{
                    marginRight: "15px",
                    cursor: "pointer",
                    marginLeft: "20px",
                    fontSize: "13.6px",
                  }}
                  onClick={() => ""}
                >
                  <div
                    className={
                      filters.status.aguardando
                        ? "number_button_gradient"
                        : "number_button_gradient-gray"
                    }
                    onClick={() => handleStatusChange("aguardando")}
                  >
                    Aguardando
                  </div>
                </div>
                <div
                  className={
                    filters.status.executado
                      ? "border_gradient"
                      : "border_gradient-gray"
                  }
                  style={{
                    marginRight: "15px",
                    cursor: "pointer",
                    fontSize: "13.6px",
                  }}
                  onClick={() => ""}
                >
                  <div
                    className={
                      filters.status.executado
                        ? "number_button_gradient"
                        : "number_button_gradient-gray"
                    }
                    onClick={() => handleStatusChange("executado")}
                  >
                    Executado
                  </div>
                </div>
                <div
                  className={
                    filters.status.erro
                      ? "border_gradient"
                      : "border_gradient-gray"
                  }
                  style={{
                    marginRight: "15px",
                    cursor: "pointer",
                    fontSize: "13.6px",
                  }}
                  onClick={() => ""}
                >
                  <div
                    className={
                      filters.status.erro
                        ? "number_button_gradient"
                        : "number_button_gradient-gray"
                    }
                    onClick={() => handleStatusChange("erro")}
                  >
                    Erro
                  </div>
                </div>
                <div
                  className={
                    filters.status.cancelado
                      ? "border_gradient"
                      : "border_gradient-gray"
                  }
                  style={{
                    marginRight: "15px",
                    cursor: "pointer",
                    fontSize: "13.6px",
                  }}
                  onClick={() => ""}
                >
                  <div
                    className={
                      filters.status.cancelado
                        ? "number_button_gradient"
                        : "number_button_gradient-gray"
                    }
                    onClick={() => handleStatusChange("cancelado")}
                  >
                    Cancelado
                  </div>
                </div>
                <div
                  className={
                    filters.status.criando
                      ? "border_gradient"
                      : "border_gradient-gray"
                  }
                  style={{
                    marginRight: "15px",
                    cursor: "pointer",
                    fontSize: "13.6px",
                  }}
                  onClick={() => ""}
                >
                  <div
                    className={
                      filters.status.criando
                        ? "number_button_gradient"
                        : "number_button_gradient-gray"
                    }
                    onClick={() => handleStatusChange("criando")}
                  >
                    Criando
                  </div>
                </div>
              </div>
              <div
                className="row-align"
                style={{ marginBottom: "30px", alignItems: "center" }}
              >
                <span style={{ color: "#002080", fontWeight: "bolder" }}>
                  Canal:{" "}
                </span>
                <select
                  value={selectedChannel}
                  onChange={(e) => {
                    setSelectedChannel(e.target.value);
                    setChangeDateFilter((previous) => !previous);
                  }}
                  className="input-values"
                  style={{ marginLeft: "20px", width: "150px" }}
                >
                  <option value="todos">Todos</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="teams">Teams</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            className="row-align"
            style={{
              justifyContent: "space-between",
              margin: "10px 20px 0px 30px",
            }}
          >
            <span style={{ color: "#002080", fontWeight: "bolder" }}>
              {dataTreat.length} resultados encontrados
            </span>
            <button
              onClick={exportListCsv}
              className="button-blue"
              style={{ width: "150px", margin: "1px" }}
            >
              {" "}
              Exportar CSV{" "}
            </button>
          </div>
          {loading && !showDevModal && (
            <div
              className="modal-overlay"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="in_loader"
                style={{ width: "50px", height: "50px" }}
              ></div>
              <h4>Carregando</h4>
            </div>
          )}
          {!loading && (
            <div>
              <table
                className="table-2024 fixed-header-table"
                style={{ backgroundColor: "#FFF", marginTop: "12px" }}
              >
                <thead>
                  <tr className="cells table-2024 border-bottom-zero">
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Nome</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("campaign_name", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() =>
                              handleInitSort("campaign_name", "desc")
                            }
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Template</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("template_name", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() =>
                              handleInitSort("template_name", "desc")
                            }
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Número de Origem</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("phone_trigger", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() =>
                              handleInitSort("phone_trigger", "desc")
                            }
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Categoria</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("category", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("category", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Data criação</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("data_criacao", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() =>
                              handleInitSort("data_criacao", "desc")
                            }
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Data de envio</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("time_trigger", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() =>
                              handleInitSort("time_trigger", "desc")
                            }
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Status</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("status", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("status", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Canal</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("erro", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("erro", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Total de disparos</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("total", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("total", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Erro</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("erro", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("erro", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Enviado não entregue</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("total", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("total", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Entregue</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("entregue", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("entregue", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Engajamento</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() => handleInitSort("engajado", "asc")}
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("engajado", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">
                      <div
                        className="row-align"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span></span>
                        <span>Usuário/Origem da Criação</span>{" "}
                        <div style={{ marginLeft: "10px" }}>
                          <div
                            className="triangle-up"
                            onClick={() =>
                              handleInitSort("triggerOrigin", "asc")
                            }
                          ></div>
                          <div
                            className="triangle-down"
                            style={{ marginTop: "4px" }}
                            onClick={() => handleInitSort("erro", "desc")}
                          ></div>
                        </div>
                      </div>
                    </th>
                    <th className="cells">Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {handleSort(dataTreat).map((trigger: any, index: number) => (
                    <React.Fragment key={index}>
                      <tr
                        key={index}
                        style={{
                          border: "1px solid #0171BD",
                          backgroundColor:
                            index % 2 === 0 ? "#ecebeb" : "white",
                        }}
                      >
                        <td>
                          <span>{trigger.campaign_name}</span>
                        </td>
                        <td>
                          <span>{trigger.template_name}</span>
                        </td>
                        <td>
                          <span>{trigger.phone_trigger ?? "--"}</span>
                        </td>
                        <td>
                          <span>
                            {capitalizeFirstLetter(trigger.category ?? "--")}
                          </span>
                        </td>
                        <td>
                          <span>
                            {trigger.data_criacao
                              ? adjustTimeWithout3Hour(trigger.data_criacao)
                              : "--"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {trigger.time_trigger
                              ? adjustTimeWithout3Hour(trigger.time_trigger)
                              : "--"}
                          </span>
                        </td>
                        <td>
                          <div
                            id="statusCells"
                            style={{ borderRadius: "20px", padding: "7px" }}
                          >
                            <span
                              style={{
                                fontWeight: "bolder",
                                color: statusColor(trigger.status),
                              }}
                            >
                              {statusName(trigger.status)}
                            </span>
                          </div>
                        </td>
                        <td>
                          <img
                            src={
                              trigger.channel === "whatsapp"
                                ? whatsappIcon
                                : teamsIcon
                            }
                            alt={
                              trigger.channel === "whatsapp"
                                ? "Whatsapp"
                                : "Teams"
                            }
                            width={20}
                            style={{ margin: "10px" }}
                          />
                        </td>
                        <td>
                          <span>{trigger.total}</span>
                        </td>
                        <td>
                          <span>{trigger.erro}</span>
                        </td>
                        <td>
                          <span>
                            {statusName(trigger.status) == "Executado" &&
                            trigger.channel === "whatsapp"
                              ? trigger.enviado
                              : "0"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {trigger.channel === "whatsapp"
                              ? trigger.entregue
                              : parseInt(trigger.enviado) +
                                parseInt(trigger.entregue)}
                          </span>
                        </td>
                        <td>
                          <span>
                            {trigger.status === "aguardando"
                              ? 0
                              : trigger.engajado}
                          </span>
                        </td>
                        <td>
                          <span>
                            {trigger.triggerOrigin === "MANUAL"
                              ? trigger.created_by || "Manual"
                              : capitalizeFirstLetter(trigger.triggerOrigin)}
                          </span>
                        </td>
                        <td>
                          <div
                            className="row-align"
                            style={{ alignItems: "center", gap: "14px" }}
                          >
                            <span
                              title="Ver detalhes"
                              onClick={() => detailedTrigger(index)}
                            >
                              <img
                                src={dots}
                                width={20}
                                alt="Ver detalhes"
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                            <span
                              title="Baixar CSV"
                              onClick={() =>
                                downloadStatus !== "loading" &&
                                downloadCustomersCsv(index)
                              }
                              style={{
                                cursor:
                                  downloadStatus === "loading"
                                    ? "default"
                                    : "pointer",
                                opacity: downloadStatus === "loading" ? 0.4 : 1,
                                display: "inline-flex",
                              }}
                            >
                              <svg
                                width={18}
                                height={18}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#0171BD"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                              </svg>
                            </span>
                            {trigger.status === "aguardando" && (
                              <span
                                title="Cancelar disparo"
                                onClick={() => changeStatus(index)}
                                style={{
                                  cursor: "pointer",
                                  display: "inline-flex",
                                }}
                              >
                                <svg
                                  width={18}
                                  height={18}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#d11a2a"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <line
                                    x1="4.93"
                                    y1="4.93"
                                    x2="19.07"
                                    y2="19.07"
                                  />
                                </svg>
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {downloadStatus !== "idle" && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.45)",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "#FFF",
                borderRadius: "20px",
                padding: "32px 40px",
                maxWidth: "420px",
                textAlign: "center",
              }}
            >
              {downloadStatus === "loading" ? (
                <>
                  <div
                    className="in_loader"
                    style={{ width: "50px", height: "50px" }}
                  ></div>
                  <h4 style={{ color: "#004488", marginTop: "16px" }}>
                    Baixando dados
                    {downloadingName ? ` de "${downloadingName}"` : ""}...
                  </h4>
                  <span style={{ color: "#555", fontSize: "13px" }}>
                    Isso pode levar alguns segundos. Não feche a página.
                  </span>
                </>
              ) : (
                <>
                  <svg
                    width={56}
                    height={56}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#25D366"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="8 12 11 15 16 9" />
                  </svg>
                  <h4 style={{ color: "#004488", marginTop: "16px" }}>
                    Download concluído com sucesso!
                  </h4>
                  <span
                    style={{
                      color: "#555",
                      fontSize: "13px",
                      marginBottom: "20px",
                    }}
                  >
                    O arquivo
                    {downloadingName ? ` de "${downloadingName}"` : ""} foi
                    baixado. Verifique a pasta de downloads do seu navegador.
                  </span>
                  <button
                    onClick={closeDownloadModal}
                    className="button-blue"
                    style={{ width: "200px" }}
                  >
                    Fechar
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TriggerList;
